import { useState, useEffect } from 'react';

/**
 * Unified page loading hook for consistent loading experience
 * @param duration - Loading duration in milliseconds (default: 300ms)
 * @returns isLoading state
 */
export const usePageLoading = (duration: number = 300) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  return isLoading;
};
